import * as R from 'ramda'
import CmsPage from 'components/cms-page'
import { AnalyticsPage } from '../../containers/analytics'
import { withApollo } from 'hoc/with-apollo'
import { LOCAL_PAGE_TYPE } from '../../pages/local/[cityOrCountrySlug]/personal-trainers'

const GET_STARTED_SECTION_EXPERIMENT = {
  fields: {
    component: 'GetStartedExperiment',
  },
}

const STICKY_CTA_SECTION_EXPERIMENT = {
  fields: {
    component: 'StickyCTAExperiment',
  },
}

const CHAT_BUTTON_EXPERIMENT = {
  fields: {
    component: 'ChatButtonExperiment',
  },
}

const COMPONENTS_BEFORE_FOOTER_EXPERIMENT = new Set(['FooterExperiment'])
const COMPONENTS_FOLLOWED_BY_FOOTER_EXPERIMENT = new Set(['FooterExperiment'])

const LocalPage = ({
  query = {},
  fields,
  isMobile,
  survey,
  locationDetails,
  localPageType,
}) => {
  const { sections: cmsSections } = fields

  const slug =
    localPageType === LOCAL_PAGE_TYPE.CITY
      ? locationDetails.city.slug
      : localPageType === LOCAL_PAGE_TYPE.STATE
      ? locationDetails.state.slug
      : locationDetails.country.slug

  const getSections = () => {
    return R.reduce(
      (allSections, section) => {
        const component = section.fields.component

        if (COMPONENTS_BEFORE_FOOTER_EXPERIMENT.has(component)) {
          allSections.push(GET_STARTED_SECTION_EXPERIMENT)
        }

        if (component !== 'SignUp') {
          allSections.push(section)
        }

        if (COMPONENTS_FOLLOWED_BY_FOOTER_EXPERIMENT.has(component)) {
          allSections.push(STICKY_CTA_SECTION_EXPERIMENT)
          allSections.push(CHAT_BUTTON_EXPERIMENT)
        }

        return allSections
      },
      [],
      cmsSections
    )
  }

  const sections = getSections()
  const reference = `local-pages-${localPageType}-${slug}`.toLowerCase()

  return (
    <AnalyticsPage
      name={`${localPageType} Page`}
      properties={{ location: `${localPageType} Page`, page: slug }}>
      <CmsPage
        query={query}
        fields={{ ...fields, sections }}
        source={reference}
        survey={survey}
        isMobile={isMobile}
        locationDetails={locationDetails}
        localPageType={localPageType}
        data-testid={reference}
        surveyId={undefined}
        coach={undefined}
        slug={undefined}
      />
    </AnalyticsPage>
  )
}

export default withApollo(LocalPage)
